// import * as ReactGA from 'react-ga'

import {IsIsset} from "helpers/ValueTests"

class GoogleAnalytic {
    constructor(core) {
        this.core = core
        this.core.store.subscribe( this.handleStoreUpdate )

        this.handleStoreUpdate()

        this.state = {
            settings_loaded: false
        }
    }

    handleStoreUpdate = () => {
        const { settings } = this.core.store.getState()

        if( IsIsset(settings) && !this.state.settings_loaded )
        {
            this.state.settings_loaded = true

            this.initialize()
        }
    }

     initialize = () => {
        // const { settings } = this.core.store.getState()
        // const { system_settings } = settings
        // const { miscellaneous } = system_settings
        // const { google_analytic } = miscellaneous
        // const { google_analytic_id } = google_analytic

        // ReactGA.initialize( google_analytic_id )

        //  if (window.gaTrackListBeforeInitialized)
        //  {
        //     window.gaTrackListBeforeInitialized.forEach((page) => {
        //         this.core.Log('[GoogleAnalytics][Lazy][TrackPage]', page)

        //         ReactGA.set({
        //             page
        //         })

        //         ReactGA.pageview(page)
        //     })
        //  }

        // <!-- Global site tag (gtag.js) - Google Analytics -->
        // <script async src="https://www.googletagmanager.com/gtag/js?id=UA-134519255-1"></script>
        // <script>
        //     window.dataLayer = window.dataLayer || [];
        //     function gtag(){dataLayer.push(arguments);}
        //     gtag('js', new Date());
        //
        //     gtag('config', 'UA-134519255-1');
        // </script>
    }

    eventAnalytic = ( action = "", label = "") => {

        console.log('[GoogleAnalytics][Event][DoctorLanding]', {
            action,
            label
        })

        window.dataLayer = window.dataLayer || [];

        window.dataLayer.push({
            event: "autoEvent",
            eventCategory: "doctor-landing",
            eventAction: action,
            eventLabel: label,
            // pageTitle: document.title
        })

        // ReactGA.event({
        //     category,
        //     action
        // })
    }
}

export default GoogleAnalytic
